/**
 * SettingsPage — Einstellungen fuer das Leadmanagement-Programm.
 *
 * Nach Phase 5.2 wurde der alte Mail-Vorlagen-Editor in den eigenen Top-Level-Tab
 * "Mail-Vorlagen" verschoben (siehe MailVorlagenPage). Hier verbleibt nur noch
 * der Listener-Status-Widget. Templates werden NICHT mehr hier editiert — der
 * Hinweis verlinkt auf den neuen Tab.
 *
 * CI-Farben: #E9FF57 / #1A1A1A / #DAD9D9.
 */

import { Link } from 'react-router-dom';
import ListenerStatusWidget from '../components/settings/ListenerStatusWidget';
import OperatingModeWidget from '../components/settings/OperatingModeWidget';

export default function SettingsPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <ListenerStatusWidget />
      <OperatingModeWidget />

      <div className="mt-6 p-4 bg-gray-50 border border-[#DAD9D9] rounded">
        <h2 className="text-base font-semibold text-[#1A1A1A]">Mail-Vorlagen</h2>
        <p className="mt-1 text-sm text-gray-600">
          Mail-Vorlagen (Erstkontakt, Follow-up 1, Follow-up 2) und deine Signatur werden im neuen
          Reiter{' '}
          <Link to="../mail-vorlagen" className="font-medium text-[#1A1A1A] underline hover:no-underline">
            Mail-Vorlagen
          </Link>{' '}
          bearbeitet.
        </p>
      </div>
    </div>
  );
}
